import OpenAI from 'openai';

/**
 * OpenAI Client Configuration
 * Initializes the OpenAI client with API key from environment variables
 */

// Validate API key on initialization
const apiKey = import.meta.env?.VITE_OPENAI_API_KEY;

if (!apiKey || apiKey === 'your-openai-api-key-here' || apiKey?.trim() === '') {
  console.warn('⚠️ OpenAI API key is not configured. AI features will not work until you add VITE_OPENAI_API_KEY to your .env file.');
}

const openai = new OpenAI({
  apiKey: apiKey || 'dummy-key', // Provide dummy key to prevent initialization error
  dangerouslyAllowBrowser: true, // Required for client-side usage in React
});

export default openai;